errorHandling:
  generic:
    fallback: Entschuldigung, etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.
    archived: Das angeforderte Element ist archiviert.
    notFound: Das angeforderte Element wurde nicht gefunden.
    unauthorised: Sie sind nicht berechtigt, diese Aktion auszuführen.
    validation: Validierung fehlgeschlagen. Bitte prüfen Sie Ihre Eingaben und versuchen Sie es erneut.
errorPage:
  gone:
    title: Diese Seite existiert nicht mehr
    defaultMessage: Die gesuchte Seite wurde möglicherweise entfernt, umbenannt oder ist vorübergehend nicht verfügbar. Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte an unser Support-Team.
    button:
      primary: Support kontaktieren
      secondary: Zurück zur Startseite
  notFound:
    title: Seite nicht gefunden
    defaultMessage: Die gesuchte Seite konnte leider nicht gefunden werden.
    button:
      primary: Support kontaktieren
      secondary: Zurück zur Startseite
  denied:
    title: Zugriff verweigert
    defaultMessage: Die Seite, auf die Sie zugreifen möchten, ist eingeschränkt und es sieht so aus, als hätten Sie keine Berechtigung. Wenden Sie sich an unser Support-Team, um mehr zu erfahren.
    button:
      primary: Support kontaktieren
      secondary: Zurück zur Startseite
  deniedProject:
    title: Zugriff auf dieses Projekt erhalten
    loggedOut: Bitte melden Sie sich an, um das Projekt anzuzeigen, oder bitten Sie ein Teammitglied, den Projektzugriff in den Freigabeeinstellungen auf „Jeder mit dem Link“ zu ändern
    loggedIn: Bitten Sie ein Teammitglied, den Projektzugriff in den Freigabeeinstellungen auf „Jeder mit dem Link“ zu ändern.
    button:
      primary: Anmelden
  crash:
    title: Etwas ist schiefgelaufen
    defaultMessage: Bitte versuchen Sie es erneut oder wenden Sie sich an unser Support-Team, wenn Sie Hilfe bei der Lösung dieses Problems benötigen.
    button:
      primary: Erneut versuchen
      secondary: Zurück zur Startseite
